module.exports = __webpack_public_path__ + "img/moneys-unchecked.073dc482.svg";